import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import MetagenicsArticlePageHeader from './MetagenicsArticle/Detail/MetagenicsArticlePageHeader';
import CardBase from '../../common/CardBase';
import MetagenicsArticleCardBody from './MetagenicsArticle/Card/MetagenicsArticleCardBody';
import MetagenicsArticleCardLinks from './MetagenicsArticle/Card/MetagenicsArticleCardLinks';
import FeaturedCard from '../../common/FeaturedCard/FeaturedCard';
import FeaturedCardDynamic from '../../common/FeaturedCard/FeaturedCardDynamic';
import BackToSearch from '../../common/BackToSearch';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import Box from '@material-ui/core/Box';

import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';

import SummaryInfo from '../SummaryInfo';
import { useSiteInfo } from '../../crafter_site_core/hooks';
import { urlFromItemPath } from '../EnterpriseContentDetailView';
import { usePencil } from '../../crafter_site_core/IceSupport';

const useStyles = makeStyles((theme) => ({
  heroDisplay: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  featuredDisplay: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  datepublishedsmall: {
    fontStyle: 'italic',
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  media: {
    height: 0,
    paddingTop: '56.25%'
  }
}));

export default function (props) {
  const {
    format,
    model: {
      craftercms: { path },
      summary = SummaryInfo(props.model),
      categories_o,
      name_s,
      position_s,
      body_html_raw,
      headshot_s,
      datePublished_dt,
      referenceBlock_html_raw,
      articleTypeSelector_s,
      articleContentSelector_s,
      caseStudySelection_o
    }
  } = props;
  const ice = usePencil(props);
  const siteinfo = useSiteInfo();
  let colourid = '';
  let articleContent = '';
  if (articleContentSelector_s) {
    const articleString = articleContentSelector_s;
    const index = articleString.indexOf(',');
    colourid = articleString.substr(0, index);
    articleContent = articleString.substr(index + 1);
  }

  let cardImgUrl = '';
  let articleType = '';

  if (articleTypeSelector_s != null) {
    articleType = articleTypeSelector_s;
  }

  if (siteinfo != null) {
    cardImgUrl = siteinfo.updateArticleDefaultCard_s;
  }

  if (summary.cardImage != null) {
    cardImgUrl = summary.cardImage;
  }

  const classes = useStyles();
  const theme = useTheme();

  const date = new Date(datePublished_dt);
  const formattedDate = new Intl.DateTimeFormat('en-AU', {
    year: 'numeric',
    month: 'long',
    day: '2-digit'
  }).format(date);

  useEffect(() => {
    document.querySelectorAll("a[href^='#']").forEach((node) => {
      node.addEventListener('click', (e) => {
        e.preventDefault();
        const id = e.target.href.substring(e.target.href.indexOf('#') + 1);
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: 'smooth' });
      });
    });
  });

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(
        window.location.hash.indexOf('#') + 1
      );
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth' });
    }
  });

  switch (format) {
    case 'DETAIL':
      return (
        <Box mb={4}>
          {/* BackToSearch is commented out until search can run with same filters on press or show same results (perhaps global context / state) when navigating back to the search page (memorisation (useMemo) not a use case for this perhaps?) */}
          <BackToSearch />
          <MetagenicsArticlePageHeader
            ice={ice}
            contenttype={articleType === 'eMed' ? 'eMed' : 'Update Article'}
            categories={categories_o}
            title={summary.title}
            subtitle={summary.subtitle}
            datepublished={formattedDate}
          />
          <Container maxWidth='lg'>
            <Box display='flex' className={classes.datepublishedsmall}>
              <CalendarTodayOutlinedIcon
                style={{ marginRight: theme.spacing(1) }}
              />
              <Typography variant='overline' style={{ fontWeight: 700 }}>
                Published: {formattedDate}
              </Typography>
            </Box>
            <Box>
              <Box display='flex' alignItems='center' height={1} width={1}>
                <Box
                  height='60px'
                  width='60px'
                  mr={1}
                  display='flex'
                  justifyContent='center'
                  alignItems='center'
                  zIndex={2}
                >
                  <img
                    src={headshot_s}
                    alt=''
                    style={{
                      width: '60px',
                      clipPath: 'circle(30px at center)'
                    }}
                  />
                </Box>
                <Box {...ice} display='flex' flexDirection='column' pl={2}>
                  <Typography variant='h6'>
                    <i>Written by: {name_s}</i>
                  </Typography>
                  <Typography
                    gutterBottom
                    style={{ color: theme.palette.primary.highlight }}
                  >
                    <strong>{position_s}</strong>
                  </Typography>
                </Box>
              </Box>
              <Box
                py={0.5}
                px={2}
                bgcolor={colourid}
                style={{ float: 'right' }}
                mt={-5}
                borderRadius={32}
                color='#ffffff'
              >
                <Typography variant='overline'>
                  <strong>
                    <small>{articleContent}</small>
                  </strong>
                </Typography>
              </Box>
              <Box position='relative' width={1} pb={2}>
                <Box
                  width={'calc(100% - 28px)'}
                  height={2}
                  bgcolor={theme.palette.primary.highlight}
                  position='absolute'
                  mt='-2px'
                  right={0}
                />
              </Box>
              {caseStudySelection_o && caseStudySelection_o[0].body_html_raw && (
                <div
                  {...ice}
                  className='articleIL bodyhtmlraw'
                  dangerouslySetInnerHTML={{
                    __html: caseStudySelection_o[0].body_html_raw
                  }}
                />
              )}
              {!caseStudySelection_o && body_html_raw && (
                <div
                  {...ice}
                  className='articleIL bodyhtmlraw'
                  dangerouslySetInnerHTML={{
                    __html: body_html_raw
                  }}
                />
              )}
            </Box>
            {referenceBlock_html_raw && (
              <Box mt={4}>
                <Typography variant='h4' gutterBottom>
                  References
                </Typography>
                <div
                  className='bodyhtmlraw'
                  dangerouslySetInnerHTML={{ __html: referenceBlock_html_raw }}
                />
              </Box>
            )}
          </Container>
        </Box>
      );
    case 'CARD':
      return (
        <>
          <CardBase
            contenttype={
              articleTypeSelector_s === 'eMed' ? 'eMed' : 'Update Article'
            }
            categories={categories_o}
          >
            <NavLink to={urlFromItemPath(path)} exact>
              <CardMedia image={cardImgUrl} className={classes.media} />
              <Box
                width={1}
                bgcolor={colourid}
                px={2}
                color='#ffffff'
                position='absolute'
                marginTop={-2.5}
              >
                <Typography variant='overline' style={{ lineHeight: 2 }}>
                  <strong>
                    <small>{articleContent}</small>
                  </strong>
                </Typography>
              </Box>
              <MetagenicsArticleCardBody
                title={summary.title}
                subtitle={summary.subtitle}
                snippet={summary.snippet}
                author={name_s}
                authorpos={position_s}
                authorimg={headshot_s}
              />
            </NavLink>
            <MetagenicsArticleCardLinks
              buttontext='read now'
              link={urlFromItemPath(path)}
            />
          </CardBase>
        </>
      );
    case 'FEATURED':
      return (
        <FeaturedCardDynamic
          contenttype={
            articleTypeSelector_s === 'eMed' ? 'eMed' : 'Update Article'
          }
          title={summary.title}
          subtitle={summary.subtitle}
          snippet={summary.snippet}
          buttontext='read now'
          categories={categories_o}
          image={cardImgUrl}
          icon='magazine'
          link={urlFromItemPath(path)}
        />
      );
    case 'HERO':
      return (
        <Container maxWidth='lg'>
          <div className={classes.heroDisplay}>
            <FeaturedCard
              contenttype={
                articleTypeSelector_s === 'eMed' ? 'eMed' : 'Update Article'
              }
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
              buttontext='read now'
              categories={categories_o}
              image={cardImgUrl}
              link={urlFromItemPath(path)}
              icon='magazine'
            />
          </div>
          <div className={classes.featuredDisplay}>
            <FeaturedCardDynamic
              contenttype={
                articleTypeSelector_s === 'eMed' ? 'eMed' : 'Update Article'
              }
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
              buttontext='read now'
              categories={categories_o}
              image={cardImgUrl}
              icon='magazine'
              link={urlFromItemPath(path)}
            />
          </div>
        </Container>
      );
    default:
      console.error(`Unknown format "${format}"."`);
      return <h1>Unknown format.</h1>;
  }
}
